import { AppDialog } from "./components/tools/AppDialog";
import { AppSnackbar } from "./components/tools/AppSnackbar";
import { DialogProvider } from "./data/providers/DialogProvider";
import { LoadingProvider } from "./data/providers/LoadingProvider";
import { SnackbarProvider } from "./data/providers/SnackbarProvider";

export const AppProviders: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <SnackbarProvider>
    <LoadingProvider>
      <DialogProvider>
        <AppDialog />
        <AppSnackbar />
        {children}
      </DialogProvider>
    </LoadingProvider>
  </SnackbarProvider>
);
